import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const TOMOS = [{
  icon: '📘',
  num: 1,
  title: 'Adultos Inicial A1',
  subtitle: 'Boas-Vindas',
  desc: 'Saludos, presentación, SER vs ESTAR, familia y rutinas cotidianas.'
}, {
  icon: '📗',
  num: 2,
  title: 'Adultos Inicial A2',
  subtitle: 'Cotidiano & Cidade',
  desc: 'Ciudad, transporte, compras, tiempo libre y restaurante.'
}, {
  icon: '📙',
  num: 3,
  title: 'Adultos Intermedio 1 B1',
  subtitle: 'Conexões & Conversação',
  desc: 'Pretérito Perfeito, Imperfeito, opinión, trabajo y planes futuros.'
}, {
  icon: '📕',
  num: 4,
  title: 'Adultos Intermedio 2 B2',
  subtitle: 'Debate & Cultura',
  desc: 'Debate, textos auténticos, cultura brasileña y registro formal.'
}, {
  icon: '📓',
  num: 5,
  title: 'Adultos Avanzado C1 Vol.1',
  subtitle: 'Expresión & Dominio',
  desc: 'Subjuntivo, registro culto, literatura y cine brasileño.'
}, {
  icon: '📔',
  num: 6,
  title: 'Adultos Avanzado C1 Vol.2',
  subtitle: 'Maestría & Autonomía',
  desc: 'Producción autónoma, análisis crítico y proyectos de cierre.'
}, {
  icon: '🧒',
  num: 7,
  title: 'Niños Vol.1',
  subtitle: 'Mundo Mágico',
  desc: 'Colores, animales, familia, canciones y cuentos en portugués.'
}, {
  icon: '🧒',
  num: 8,
  title: 'Niños Vol.2',
  subtitle: 'Histórias & Aventuras',
  desc: 'Clima, ciudades de Brasil, historias y proyecto integrador.'
}, {
  icon: '🗣️',
  num: 9,
  title: 'Fonética Avanzada',
  subtitle: 'Sotaque & Pronúncia',
  desc: 'Pronunciación brasileña, diferencias con el español rioplatense.'
}, {
  icon: '✍️',
  num: 10,
  title: 'Ensayos & Portfolio',
  subtitle: 'Escrita Acadêmica',
  desc: 'Ensayos académicos, textos formales y portfolio de cierre de nivel.'
}, {
  icon: '🏆',
  num: 11,
  title: 'CELPE-Bras Vol.1',
  subtitle: 'Preparação Oficial',
  desc: 'Estructura del examen, tareas comunicativas y primeros simulacros.'
}, {
  icon: '🏆',
  num: 12,
  title: 'CELPE-Bras Vol.2',
  subtitle: 'Simulacros & Certificação',
  desc: 'Simulacros completos, estrategias y corrección detallada.'
}];
const CHECKLIST = ['Secuencia didáctica completa (objetivo, desarrollo y evaluación)', 'Actividades listas para imprimir', 'Evaluación formativa incluida', 'Rúbrica de corrección lista', 'Checklist docente al final', 'Imágenes ilustrativas incluidas'];
export function TomosGrid() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-336">
      <div className="max-w-6xl mx-auto" data-id="element-337">
        <div className="text-center mb-16" data-id="element-338">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-deep-green mb-4" data-id="element-339">
            🇧🇷 LOS 12 TOMOS — Todo el año resuelto
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-500" data-id="element-340">
            Para docentes de Português de todos los niveles
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-341">
          {TOMOS.map((tomo, i) => <motion.div key={tomo.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} whileHover={{
          y: -5
        }} className="bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md transition-all border-l-4 border-l-deep-green p-6 flex flex-col h-full" data-id="element-342">
              <div className="flex items-start gap-4 mb-4" data-id="element-343">
                <span className="text-3xl" data-id="element-344">{tomo.icon}</span>
                <div data-id="element-345">
                  <div className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-346">
                    Tomo {tomo.num} — {tomo.title}
                  </div>
                  <h3 className="text-lg font-bold text-deep-green leading-tight" data-id="element-347">
                    "{tomo.subtitle}"
                  </h3>
                </div>
              </div>
              <p className="text-gray-600 text-sm mt-auto leading-relaxed" data-id="element-348">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-light-green rounded-2xl p-8 border border-green-200" data-id="element-349">
          <h3 className="text-xl font-bold text-deep-green text-center mb-6" data-id="element-350">
            Cada tomo incluye:
          </h3>
          <div className="space-y-4" data-id="element-351">
            {CHECKLIST.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-352">
                <span className="text-green-600 mt-0.5 flex-shrink-0" data-id="element-353">✅</span>
                <span className="text-gray-800 font-medium" data-id="element-354">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}